<template>
    <div>
        <h1>RENJA PENDAPATAN</h1>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
